module.exports = __webpack_public_path__ + "img/wechat_pay_logo.0980c80b.png";